import { ApolloClient, InMemoryCache, HttpLink } from 'apollo-boost';
import fetch from 'unfetch';

export default {
    data() {
        return {
            GraphQlClient: null,
        };
    },
    methods: {
        createGraphQlClient(uri, headers = {}) {
            const httpLink = new HttpLink({
                uri,
                fetch,
                headers,
            });

            const client = new ApolloClient({
                link: httpLink,
                cache: new InMemoryCache(),
            });
            this.GraphQlClient = client;
        },
        async graphQlQuery(query, variables) {
            if (this.GraphQlClient === null) {
                const err = 'GraphQlClient: Not initialized';
                return new Promise((reject) => {
                    reject(err);
                });
            }

            try {
                const result = await this.GraphQlClient.query({
                    query,
                    variables: variables || undefined,
                });

                return new Promise((resolve) => {
                    resolve(result.data);
                });
            } catch (e) {
                return new Promise((reject) => {
                    reject(e);
                });
            }
        },
    },
};
